import React, { FC, useContext } from 'react';
import LeadsList from 'Containers/LeadsList';
import UserDetailsContext from 'Context/userDetailsContext';

const List: FC<any> = () => {
  const userDetails = useContext(UserDetailsContext);

  return (
    <LeadsList instId={userDetails.instId} accountId={userDetails.accountId} />
  );
};

export default List;
try {
    // @ts-ignore
    List.displayName = "List";
    // @ts-ignore
    List.__docgenInfo = { "description": "", "displayName": "List", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/pages/Leads/List/List.tsx#List"] = { docgenInfo: List.__docgenInfo, name: "List", path: "src/pages/Leads/List/List.tsx#List" };
}
catch (__react_docgen_typescript_loader_error) { }